import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import DataTable from '../../../common/data-table/DataTable'
import PageHeader from '../../../layout/page/PageHeader'
import { FilterMatchMode } from 'primereact/api'
import { ButtonGroup } from 'react-bootstrap'
import TableCellPopup from '../../../common/dialogs/TableCellPopup'
import { useAppSelector } from '../../../../store/hooks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

const Translations = () => {
    const theme = useAppSelector((state) => state.theme.theme)
    const [refreshTable] = useState(false)

    const actionsBodyTemplate = (rowData) => {
        return (
            <ButtonGroup size="sm">
                <NavLink
                    to={'/administration/translations/view/' + rowData.id}
                    className="btn btn-outline-primary ms-1"
                >
                    <FontAwesomeIcon icon={faEdit} />
                </NavLink>
            </ButtonGroup>
        )
    }

    const defaultTextTemplate = (rowData) => (
        <TableCellPopup rowData={rowData} />
    )

    return (
        <>
            <PageHeader
                icon="language"
                subtitle="Translate content across all supported languages"
                gradient="linear-gradient(135deg, #8b5cf6, #7c3aed)"
                header="Translations"
                buttons={[
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                ]}
            />
            <DataTable
                refreshTable={refreshTable}
                config={{
                    dataRoute: '/administration/languages/general-translations',
                    first: 0,
                    rows: 10,
                    page: 0,
                    sortField: 'name',
                    sortOrder: 1,
                    filters: {
                        global: {
                            value: null,
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        name: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        text: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        location: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                    },
                    filterDisplay: 'menu',
                }}
                columns={[
                    {
                        field: 'name',
                        header: 'Name',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                        style: {
                            maxWidth: '15rem',
                        },
                    },
                    {
                        field: 'location',
                        header: 'Location',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                        style: {
                            maxWidth: '4rem',
                        },
                    },
                    {
                        field: 'text',
                        header: 'Text',
                        sortable: false,
                        filter: true,
                        filterPlaceholder: 'Search',
                        body: defaultTextTemplate,
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '11rem',
                            minWidth: '11rem',
                            maxWidth: '11rem',
                        },
                        style: {
                            width: '11rem',
                            minWidth: '11rem',
                            maxWidth: '11rem',
                        },
                    },
                    {
                        field: 'id',
                        header: 'Actions',
                        sortable: false,
                        body: actionsBodyTemplate,
                        alignHeader: 'center',
                        headerStyle: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        style: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        toggleVisibility: false,
                    },
                ]}
                globalFilterFields={['name', 'location', 'text']}
            />
        </>
    )
}

export default Translations
